// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flightInfo__date-fp5kN";
var _3 = "flightInfo__airline-2DJgR";
var _4 = "aircraft-22XOn";
var _5 = "segment-XlJyz";
var _6 = "segment_additional-1zLRl";
var _7 = "totalDuration__decorator-Lc-JS";
var _8 = "flightInfo__nextDay-KlIrp";
var _9 = "planeInfo-3oKGN";
export { _1 as "__esModule", _2 as "flightInfo__date", _3 as "flightInfo__airline", _4 as "aircraft", _5 as "segment", _6 as "segment_additional", _7 as "totalDuration__decorator", _8 as "flightInfo__nextDay", _9 as "planeInfo" }
export default { "__esModule": _1, "flightInfo__date": _2, "flightInfo__airline": _3, "aircraft": _4, "segment": _5, "segment_additional": _6, "totalDuration__decorator": _7, "flightInfo__nextDay": _8, "planeInfo": _9 }
